// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__b_W5l","title":"styles_title__nHb2u","newsDescription":"styles_newsDescription__b4kpZ"};